var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid h-100 p-0 pt-3 pb-5" }, [
    _c("div", { staticClass: "card customer-card shadow-sm h-100" }, [
      _c("div", { staticClass: "block-padding" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-new-creative d-flex align-items-center text-nowrap gap-2",
              attrs: {
                disabled: !_vm.selectedTemplateIds.length,
                "data-ai-agent-id": "new-creative-btn",
                "data-ai-agent-type": "button",
                "data-ai-agent-label": "New Creative",
              },
              on: { click: _vm.createNewCreative },
            },
            [
              _c("img", {
                attrs: {
                  src: "/images/customer/plus.png",
                  width: "20",
                  height: "20",
                },
              }),
              _vm._v("\n          New Creative\n        "),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c("CustomersDropdown", {
              ref: "customersDropdown",
              attrs: { customers: _vm.customers },
              on: { select: _vm.onSelectCustomer },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center mb-3 b-header",
          },
          [
            _c("h5", { staticClass: "mb-0 customer-h5" }, [
              _vm._v("\n          Template Categories\n        "),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "category-filter p-3 m-0 d-flex" },
              _vm._l(_vm.categories, function (category) {
                return _c(
                  "li",
                  {
                    key: category,
                    staticClass: "category-item",
                    class: { active: _vm.activeCategory === category },
                    on: {
                      click: function ($event) {
                        return _vm.filterCategory(category)
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(category) + "\n          ")]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "search-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery",
                  },
                ],
                staticClass: "form-control search-input",
                attrs: {
                  type: "text",
                  placeholder: "Search",
                  "data-ai-agent-type": "input",
                  "data-ai-agent-id": "templates-search-input",
                  "data-ai-agent-label": "Templates Search",
                },
                domProps: { value: _vm.searchQuery },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.loadTemplates.apply(null, arguments)
                  },
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.searchQuery = $event.target.value
                    },
                    _vm.loadTemplates,
                  ],
                },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "templates-block d-flex flex-wrap",
            attrs: {
              "data-ai-agent-type": "template-list",
              "data-ai-agent-id": "templates-list",
              "data-ai-agent-label": "Templates List",
            },
          },
          _vm._l(_vm.filteredTemplates, function (template) {
            return _c(
              "div",
              {
                key: template.id,
                staticClass: "template-card-col",
                attrs: {
                  "data-ai-template-id": template.id,
                  "data-ai-template-name": template.name,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card template-card",
                    class: { selected: _vm.isSelected(template.id) },
                    on: {
                      click: function ($event) {
                        return _vm.toggleSelection(template.id)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "h-100 d-flex justify-content-center align-items-center",
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              template.image ||
                              "/images/customer/default-template-image.png",
                            height: "102",
                            width: "102",
                            alt: "Template Image",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "template-card-body d-flex align-items-center justify-content-between",
                      },
                      [
                        _c("h5", { staticClass: "template-card-title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.truncatedName(template.name)) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-select",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.toggleSelection(template.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.isSelected(template.id)
                                    ? "Deselect"
                                    : "Select"
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: {
            "data-ai-agent-type": "pagination",
            "data-ai-agent-id": "templates-pagination",
            "data-ai-agent-label": "Templates Pagination",
          },
        },
        [
          _vm.filteredTemplates.length > 0
            ? _c("VuePagination", {
                attrs: {
                  pagination: _vm.pagination,
                  "class-name": "hero-files-pagination",
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                  paginate: _vm.loadTemplates,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "mb-2 customer-h3-title" }, [
        _vm._v("\n            Create From Template\n          "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted mb-0" }, [
        _vm._v("\n            Select a template to start with\n          "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }